import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import fr from "./locales/fr/common.json";
import en from "./locales/en/common.json";

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      fr: { translation: fr },
      en: { translation: en },
    },
    fallbackLng: "fr",
    supportedLngs: ["fr", "en"],
    detection: {
      order: ["localStorage"],
      lookupLocalStorage: "djilu_language",
      caches: ["localStorage"],
    },
    interpolation: { escapeValue: false },
  });

// Update html lang attribute on language change
i18n.on("languageChanged", (lng) => {
  document.documentElement.lang = lng;
});
// Set initial lang
document.documentElement.lang = i18n.language?.startsWith("fr") ? "fr" : i18n.language?.startsWith("en") ? "en" : "fr";

export default i18n;
